<template>
  <div class="container">
    <v-sheet
    color="blue">
      <v-carousel
        :show-arrows="false"
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        height="350">
        <v-carousel-item
          v-for="i in 3"
          :key="i">
          <v-sheet
            color="blue darken-3"
            tile>
            <v-img
              height="360"
              class="align-end"
              src="http://47.94.10.11/static/files/slider.jpg">
              <div
                class="yellow--text text--lighten-3 ma-8">
                  <div class="d-flex align-center">
                    <v-icon large class="mr-5">mdi-google-maps</v-icon>
                    <span class="text-h5 ma-1">服务全球</span>
                  </div>
                  <div class="d-flex align-center">
                    <v-icon large class="mr-4">mdi-phone-classic</v-icon>
                    <span class="text-h4 ma-1 font-weight-black">0411-86283078</span>
                  </div>
              </div>
            </v-img>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-sheet>
    <v-sheet
      rounded
      color="green lighten-5"
      class="cube mt-4">
      <v-sheet
        color="green lighten-5"
        width="336"
        tile
        class="pl-2">
        <cube incolor="green lighten-5" v-if="cubeitems.length" :items="items_format" @cube_hover="cube_click"/>
      </v-sheet>
      <v-sheet>
        <v-window
          v-model="tabflag">
          <v-window-item
            v-for="i in cubeitems"
            :value="i.id"
            :key="i.id">
            <v-card
              tile
              color="indigo"
              width="530"
              min-height="320">
              <v-img
                class="align-start"
                height="220px"
                src="http://47.94.10.11/static/files/cubeimg3.jpg">
                <v-sheet
                  class="grey darken-1 white--text text-h6 font-weight-black pa-1">
                  <v-icon large color="white" class="mr-4">mdi-comment-quote</v-icon>
                  <span>诚信 企业屹立的基石</span>
                </v-sheet>
              </v-img>
              <v-card-text class="white--text">
                <div>
                  <span class="text-h5 mr-2">{{i[$store.state.lang+'_name']}}</span>
                  <span class="text-subtitle-2">{{i[$store.state.lang+'_content'].split('|')[0]}}</span>
                </div>
                <div>{{i[$store.state.lang+'_content'].split('|')[1]}}</div>
              </v-card-text>
            </v-card>
          </v-window-item>
        </v-window>
      </v-sheet>
    </v-sheet>
    
    <v-card
      outlined
      color="blue-grey lighten-1"
      class="my-4">
      <v-sheet class="pa-4" text-truncate max-height="235" color="blue-grey lighten-1" dark v-html="aboutus[$store.state.lang+'_content']"></v-sheet>
      <v-card-actions class="d-flex justify-end">
        <v-btn dark color="indigo" @click="$router.push('/about')" >
          <span v-if="$store.state.lang == 'cn'">详细信息</span>
          <span v-else>MORE</span>
        </v-btn>
      </v-card-actions>
    </v-card>
    
    <Hotsalebar>
      <template v-slot:header>
        <v-sheet tile dark color="light-blue darken-3" class="d-flex justify-end align-center px-4" height="30">
          <v-icon color="white" small>mdi-cart-arrow-down</v-icon>
          <div class="divider"></div>
          <span v-if="$store.state.lang == 'cn'">热销品</span>
          <div class="divider"></div>
          <span>HOT SALE</span>
        </v-sheet>
      </template>
    </Hotsalebar>
    
    <v-card
      class="my-4"
      outlined>
      <v-sheet color="light-blue darken-3" dark tile class="d-flex justify-start align-center px-4" height="30">
        <span v-if="$store.state.lang == 'cn'">品牌墙</span>
        <div class="divider"></div>
        <span>HOT BRAND</span>
        <div class="divider"></div>
        <v-icon color="white">mdi-tag-outline</v-icon>
      </v-sheet>
      <Brandswall/>
    </v-card>
    
    <v-sheet color="" class="my-2 pb-1">
      <div class="listbox">
        <div class="list1">
          <Newsbar :minh="450" :istile="false" :isoutlined="false">
            <template v-slot:header>
              <v-sheet class="pl-4 d-flex justify-start align-center" tile color="grey darken-2 white--text" height="30">
                <v-icon color="white">mdi-newspaper-variant-outline</v-icon>
                <div class="divider"></div>
                <span v-if="$store.state.lang == 'cn'">新闻中心</span>
                <div class="divider"></div>
                <span>NEWS</span>
              </v-sheet>
            </template>
            <template v-slot:img>
              <v-img class="mb-4" :aspect-ratio="9/2" height="200" src="http://47.94.10.11/static/files/d16e5f07aa6a70bc.gif"></v-img>
            </template>
          </Newsbar>
        </div>
        <div class="list3">
          <Contactbar :minh="450" :istile="false" :isoutlined="false">
            <template v-slot:header>
              <v-sheet class="pl-4 d-flex justify-start align-center" tile color="grey darken-2 white--text" height="30">
                <v-icon color="white">mdi-card-account-phone</v-icon>
                <div class="divider"></div>
                <span v-if="$store.state.lang == 'cn'">联系我们</span>
                <div class="divider"></div>
                <span>CantactUs</span>
              </v-sheet>
            </template>
            <template v-slot:img>
              <v-img :aspect-ratio="9/2" height="150" src="http://47.94.10.11/static/files/contactbar.gif"></v-img>
            </template>
          </Contactbar>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import Cube from '@/components/Cube.vue'
import Brandswall from '@/components/Brandswall.vue'
import Newsbar from '@/components/Newsbar.vue'
import Categorytree from '@/components/Categorytree.vue'
import Contactbar from '@/components/Contactbar.vue'
import Hotsalebar from '@/components/Hotsalebar.vue'

export default {
  name: 'Home',
  components: {
    Cube,
    Brandswall,
    Newsbar,
    Categorytree,
    Contactbar,
    Hotsalebar
  },
  data(){
    return{
      aboutus:{},
      aboutus_io_api:'about/io/',
      cubeitem_io_api:'cubeitem/io/',
      cubeitems:[],
      tabflag:0,
    }
  },
  computed:{
    items_format(){
      let blankbox = [1,4,8,9,12];
      let index = 0;
      let tmp = [];
      for(let i = 0;i < 12;i++){
        if(blankbox.includes(i+1)){
          tmp[i] = {'id':'blank'};
        }else{
          tmp[i] = this.cubeitems[index];
          index++;
        }
      }
      return tmp
    },
  },
  methods:{
    cube_click(v){
      this.tabflag = v;
    },
    fetch(){
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.aboutus_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.aboutus = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
    fetch_cube_item(){
      let postdata = {};
      this.$axios.post(this.$store.state.baseurl + this.cubeitem_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.cubeitems = response.data.data;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
    this.fetch_cube_item();
  }
}
</script>

<style scoped>
.container{
  height:100%;
}
.cube{
  padding:0px 10px;
  display:flex;
  justify-content:space-around;
}
.tabbody{
  height:90%;
  width:100%;
  background:#369;
  border-radius:8px;
}
.advbox{
  display:flex;
  justify-content:center;
}
.listbox{
  width:100%;
  display:flex;
  justify-content:space-around;
}
.list1{
  width:60%;
}
.list3{
  flex-grow:1;
  border-left:1px solid #eee;
}
.divider{
  height:50%;
  width:2px;
  background:#fff;
  margin:0 8px;
}
</style>
